import { Input, Optional, Directive, ElementRef } from '@angular/core';
import { D3ChartDirective, D3Element, D3Scale, D3MarginDirective } from './chart';
import * as d3 from 'd3';


export class D3BarsDirective extends D3Element {
   name: string;
   barWidth = 15;
   xDataName: string;
   yDataName: string;
   xScaleName: string;
   yScaleName: string;

  private _barsElement;
  private _xScale: D3Scale;
  private _yScale: D3Scale;

  constructor(chart: D3ChartDirective, el: ElementRef,  margin?: D3MarginDirective) {
    super(chart, el, margin);
    this._barsElement = this.element.attr('class', 'bars');
  }

  redraw() {
    const data = this.data;
    const bars = this._barsElement.selectAll('rect.bar').data(data);

    bars.exit().transition().duration(500)
      .attr('y', () => this.height)
      .attr('height', 0)
      .remove();

    bars.transition().duration(500)
      .attr('x', (d: any) => this.x(d[this.xDataName]) - this.barWidth / 2)
      .attr('y', (d: any) => this.y(d[this.yDataName]))
      .attr('height', (d: any) => this.height - this.y(d[this.yDataName]))
      .attr('width', this.barWidth);

    bars.enter()
      .append('rect')
      .attr('class', (d, i) => `bar bar-${i}`)
      .attr('x', (d: any) => this.x(d[this.xDataName]) - this.barWidth / 2)
      .attr('y', () => this.height)
      .attr('height', 0)
      .attr('width', this.barWidth)
      .transition().duration(500)
      .attr('y', (d: any) => this.y(d[this.yDataName]))
      .attr('height', (d: any) => this.height - this.y(d[this.yDataName]));
  }

  private get x() {
    return (this._xScale = this._xScale
      || this.getScale(this.xScaleName || this.xDataName)).scale;
  }

  private get y() {
    return (this._yScale = this._yScale
      || this.getScale(this.yScaleName || this.yDataName)).scale;
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[d3-bars]'
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: D3ChartDirective, },
{type: ElementRef, },
{type: D3MarginDirective, decorators: [{ type: Optional }, ]},
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'name': [{ type: Input },],
'barWidth': [{ type: Input, args: ['width', ] },],
'xDataName': [{ type: Input, args: ['x', ] },],
'yDataName': [{ type: Input, args: ['y', ] },],
'xScaleName': [{ type: Input, args: ['xscale', ] },],
'yScaleName': [{ type: Input, args: ['yscale', ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
